import { useFirestoreID } from '../../firebase/useFirestore';
import PageHeader from '../layout/PageHeader.jsx';
import submissionDate from '../../helpers/questionnaire/submissionDate';
import submissionHeaderDescription from '../../helpers/questionnaire/submissionHeaderDescription';

const DATE_OPTIONS = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };

/**
 * De kop boven één ingevulde vragenlijst: onderzoek, eventueel de respondent,
 * en daaronder datum, meetmoment en aantal antwoorden.
 *
 * Datum, meetmoment en telling komen alle drie uit dezelfde antwoordenreeks, dus
 * ze staan hier één keer beschreven in plaats van per scherm.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {object} props
 * @param {string} props.heading - De titel van het onderzoek.
 * @param {string} [props.subHeading] - Bijvoorbeeld de naam van de respondent.
 * @param {Array<object>} props.responses - Alle antwoorden van deze inzending.
 */
const ResearchResultsPageHeader = ({ heading, subHeading, responses }) => {
    const rows = Array.isArray(responses) ? responses : [];
    const momentId = rows[0] ? rows[0].MomentID : '';

    const moments = useFirestoreID('MeasureMoments', momentId || '');
    const momentTitle = Array.isArray(moments) && moments[0] ? moments[0].Title : '';

    const date = submissionDate(rows);

    return (
        <PageHeader
            heading={heading}
            subHeading={subHeading}
            description={submissionHeaderDescription({
                dateLabel: date ? date.toLocaleDateString('nl-NL', DATE_OPTIONS) : '',
                momentTitle,
                answerCount: rows.length,
            })}
            AI={false}
        />
    );
};

export default ResearchResultsPageHeader;
